export enum LoraForwarderState {
  Unknown = 'unknown',
  Starting = 'starting',
  Running = 'running',
  Stopping = 'stopping',
  Stopped = 'stopped',
  Failed = 'failed',
}

export const LoraForwarderStateColor = new Map([
  [LoraForwarderState.Unknown, 'grey'],
  [LoraForwarderState.Starting, 'blue'],
  [LoraForwarderState.Running, 'green'],
  [LoraForwarderState.Stopping, 'blue'],
  [LoraForwarderState.Stopped, 'orange'],
  [LoraForwarderState.Failed, 'red'],
]);
